import type { Port } from "../../../util/src/blueprint/types.js";
import type { BehaviorAnimationPayload } from "../../../util/src/blueprint/runtime/types.js";

/**
 * Applies scene animation timing defaults to an `animPlay` node's ports when its
 * animation name is set or preset (same behavior as the former name dropdown).
 *
 * @param ports - Current `animPlay` ports.
 * @param animationName - Selected animation name.
 * @param sceneAnimationsByName - Scene animation payloads keyed by lowercase name.
 * @returns Ports with `name` and timing fields updated from the payload when found.
 */
export function applyAnimPlayDefaultsToPorts(
  ports: Port[],
  animationName: string,
  sceneAnimationsByName: Record<string, BehaviorAnimationPayload>,
): Port[] {
  const payload = sceneAnimationsByName[animationName.toLocaleLowerCase()];
  return ports.map((port) => {
    if (port.id === "name") {
      return { ...port, value: animationName };
    }
    if (!payload) return port;
    if (port.id === "durationMs") {
      return { ...port, value: payload.durationMs };
    }
    if (port.id === "delayMs") {
      return { ...port, value: payload.delayMs };
    }
    if (port.id === "iterationCount") {
      return { ...port, value: payload.iterationCount };
    }
    if (port.id === "direction") {
      return { ...port, value: payload.direction };
    }
    if (port.id === "fillMode") {
      return { ...port, value: payload.fillMode };
    }
    return port;
  });
}
